<template>
  <el-table
    ref="VirtualScrollTable"
    class="virtual-scroll-table"
    :height="height"
    :data="renderData"
    :span-method="spanMethod"
    :sort-orders="sortOrders"
    @sort-change="onSortChange"
    :row-style="rowStyle"
    :cell-style="cellStyle"
    :header-cell-style="headerCellStyle"
  >
    <el-table-column v-if="selectable" :fixed="selectColumnFixed" :width="selectColumnWidth">
      <template slot="header" slot-scope="{}">
        <el-checkbox :value="checkedAll" @change="onSelectAll" :indeterminate="indeterminate"></el-checkbox>
      </template>
      <template slot-scope="scope">
        <el-checkbox
          :key="'_checkbox_' + scope.row._origin_index_"
          :value="checkCheckedItem(scope)"
          @change="(val) => onSelectItem(scope, val)"
        ></el-checkbox>
      </template>
    </el-table-column>
    <slot></slot>
  </el-table>
</template>

<script>
import ScrollParent from 'scrollparent';

export default {
  name: 'VirtualScrollTable',
  props: {
    spanMethod: Function,
    data: Array,
    rowHeight: Number, // 设置每行高度 当行高不固定时，可以不指定行高度
    minRowSize: {
      // 可变行高时，设置初始行高
      type: Number,
      default: 100,
    },
    height: [Number, String], // 表格高度
    pageMode: Boolean, // 当不指定表格高度，设置为true，可以使用页面滚动
    selectable: Boolean, // 是否启动多选
    selectColumnWidth: {
      // 多选列宽度
      type: Number,
      default: 45,
    },
    sortOrders: Array,
    rowStyle: [Function, Object],
    cellStyle: [Function, Object],
    headerCellStyle: [Function, Object],
    selectColumnFixed: Boolean,
    resetTop: {
      // 重置表格滚动位置
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      renderData: [], // 要渲染的数据
      selection: [],
    };
  },
  computed: {
    checkedAll() {
      return this.data.length > 0 && this.selection.length === this.data.length;
    },
    indeterminate() {
      return this.selection.length > 0 && !this.checkedAll;
    },
  },
  watch: {
    data(oldv, newv) {
      if (oldv !== newv) {
        this.selection = [];
      }
      this.refreshVirtualData();
    },
  },
  created() {
    this.rowHeightCache = [];
    this.startIndex = 0;
    this.endIndex = 0;
    this.offsetNum = 5;
  },
  mounted() {
    if (this.pageMode) {
      this.applyPageMode();
    } else {
      this.getScrollWarppers().warpper.addEventListener('scroll', this.onVirtualScroll);
    }
    if (!this.init) {
      this.refreshVirtualData();
    }
  },
  beforeDestroy() {
    if (this.pageMode) {
      this.removeListeners();
    }
  },
  methods: {
    async updateRenderData() {
      await this.$nextTick();
      const { offsetNum, data } = this;
      const { warpper, warppers } = this.getScrollWarppers();
      let scrollTop = warppers[0].scrollTop || 0;
      let viewportHeight = warpper.clientHeight;
      if (this.pageMode) {
        const container = this.getListenerTarget();
        scrollTop = container.scrollTop;
        viewportHeight = window.innerHeight;
      }
      let startIndex = 0;
      let endIndex = 0;
      let renderData = [];
      let placeholderHeight = 0;
      let top = 0;
      if (this.rowHeight) {
        // 通过offsetHeight计算startIndex和endIndex
        const offsetHeight = offsetNum * this.rowHeight;
        startIndex = Math.floor((scrollTop - offsetHeight) / this.rowHeight);
        endIndex = Math.ceil((scrollTop + offsetHeight + viewportHeight) / this.rowHeight);
        if (startIndex < 0) startIndex = 0;
        if (endIndex > data.length) endIndex = data.length;
        renderData = data.slice(startIndex, endIndex);
        placeholderHeight = data.length * this.rowHeight - renderData.length * this.rowHeight;
        top = startIndex * this.rowHeight;

        // 通过offsetNum计算startIndex和endIndex
        // const offsetIndex = Math.floor(scrollTop / this.rowHeight);
        // const viewportCount = Math.ceil(viewportHeight / this.rowHeight);
        // if (offsetIndex - offsetNum < 0) {
        //   startIndex = 0;
        // } else {
        //   startIndex = offsetIndex - offsetNum;
        // }
        // if (offsetIndex + viewportCount + offsetNum > data.length - 1) {
        //   startIndex = data.length - 1 - offsetNum - viewportCount - offsetNum;
        // }
        // endIndex = viewportCount + offsetIndex + offsetNum;
        // if (endIndex > data.length) endIndex = data.length;
        // renderData = data.slice(startIndex, endIndex);
        // placeholderHeight = data.length * this.rowHeight - renderData.length * this.rowHeight;
        // top = startIndex * this.rowHeight;
      } else {
        let offsetIndex = 0; // 屏幕中显示的第一个元素位置
        let viewportCount = 0;
        let renderHeight = 0;
        if (scrollTop > 0) {
          for (let i = 0; i < this.data.length; i++) {
            if (scrollTop - this.tableOffsetTop >= this.rowHeightCache[i].top && scrollTop - this.tableOffsetTop <= this.rowHeightCache[i].bottom) {
              offsetIndex = i;
              break;
            }
          }
        }
        if (offsetIndex === 0 && this.data.length > 0 && scrollTop - this.tableOffsetTop > this.rowHeightCache[this.rowHeightCache.length - 1].bottom) {
          offsetIndex = this.rowHeightCache.length - 1;
        }
        for (let i = offsetIndex; i < this.data.length; i++) {
          // TODO 最后一屏的计算有问题
          if (this.rowHeightCache[i].bottom >= scrollTop + viewportHeight) {
            viewportCount = i - offsetIndex;
            break;
          }
        }
        // 暂时解决最后一屏的计算问题
        if (viewportCount === 0) {
          viewportCount = this._lastViewportCount || 0;
        }
        this._lastViewportCount = viewportCount;
        if (
          this.rowHeightCache.length > 0 &&
          viewportCount > 0 &&
          this.rowHeightCache.length - viewportCount >= 0 &&
          scrollTop - this.tableOffsetTop >= this.rowHeightCache[this.rowHeightCache.length - viewportCount].bottom
        ) {
          offsetIndex = this.rowHeightCache.length - viewportCount;
        }
        if (offsetIndex - offsetNum < 0) {
          startIndex = 0;
        } else {
          startIndex = offsetIndex - offsetNum;
        }
        if (offsetIndex + viewportCount + offsetNum > data.length - 1) {
          startIndex = data.length - 1 - offsetNum - viewportCount - offsetNum;
          if (startIndex < 0) {
            startIndex = 0;
          }
        }
        endIndex = viewportCount + offsetIndex + offsetNum;
        if (endIndex > data.length) endIndex = data.length;
        this.startIndex = startIndex;
        this.endIndex = endIndex;

        renderData = data.slice(startIndex, endIndex);
        if (this.rowHeightCache.length > 0) {
          for (let i = startIndex; i < endIndex; i++) {
            renderHeight += this.rowHeightCache[i].height;
          }
          placeholderHeight = this.rowHeightCache[this.rowHeightCache.length - 1].bottom - renderHeight;
          top = this.rowHeightCache[startIndex].top;
          this._oldplaceholderHeight = placeholderHeight;
        }
      }
      warppers.forEach((el) => {
        let placeholder = el.querySelector('.virtual-scroll-placeholder');
        if (placeholder) {
          placeholder.style.height = `${placeholderHeight}px`;
        } else {
          placeholder = document.createElement('div');
          placeholder.setAttribute('class', 'virtual-scroll-placeholder');
          placeholder.style.height = `${placeholderHeight}px`;
          el.appendChild(placeholder);
        }
        el.querySelector('.el-table__body').style.transform = `translate3d(0,${top}px,0)`;
      });
      if (JSON.stringify(renderData) !== JSON.stringify(this.renderData)) {
        this.renderData = renderData;
      }

      if (!this.rowHeight) {
        this.$nextTick(() => {
          this.cacheRowHeight(startIndex);
          this.$refs.VirtualScrollTable.doLayout();
        });
      }
    },
    onExpandRow() {
      if (this.pageMode) {
        return;
      }
      this.cacheRowHeight(this.startIndex);
      this.updateRenderData();
    },
    refreshVirtualData() {
      this.init = true;
      if (!this.data || this.data.length === 0) {
        this.renderData = [];
      }
      this.data.forEach((item, index) => {
        // eslint-disable-next-line no-underscore-dangle
        item._origin_index_ = index;
      });
      const { warpper, warppers } = this.getScrollWarppers();
      if (this.resetTop) {
        warppers.forEach((el) => {
          el.scrollTop = 0;
        });
      }
      this.tableOffsetTop = this.getElementTop(warpper);
      
      this.rowHeightCache = [];
      if (!this.rowHeight) {
        this.data.forEach((item, i) => {
          this.rowHeightCache[i] = {
            top: i > 0 ? this.rowHeightCache[i - 1].bottom + 1 : 0,
            bottom: i > 0 ? this.rowHeightCache[i - 1].bottom + 1 + this.minRowSize : this.minRowSize,
            height: this.minRowSize,
          };
        });
      }
      this.updateRenderData();
    },
    onVirtualScroll() {
      window.requestAnimationFrame(this.updateRenderData);
    },
    getScrollWarppers() {
      const el = this.$refs.VirtualScrollTable.$el;
      const warpper = el.querySelector('.el-table__body-wrapper');
      const fixedWrapper = el.querySelector('.el-table__fixed .el-table__fixed-body-wrapper');
      const rightFixedWrapper = el.querySelector('.el-table__fixed-right .el-table__fixed-body-wrapper');
      const warppers = [warpper, fixedWrapper, rightFixedWrapper].filter((v) => v);
      return {
        warpper,
        warppers,
      };
    },
    cacheRowHeight(startIndex) {
      const { warpper } = this.getScrollWarppers();
      const trs = [...warpper.children[0].children[1].children];
      trs.forEach((tr, index) => {
        const i = startIndex + index;
        this.rowHeightCache[i] = {
          top: i > 0 ? this.rowHeightCache[i - 1].bottom + 1 : 0,
          bottom: i > 0 ? this.rowHeightCache[i - 1].bottom + 1 + tr.clientHeight : tr.clientHeight,
          height: tr.clientHeight,
        };
      });
      // 刷新高度
      this.data.forEach((item, i) => {
        if (i > startIndex + trs.length - 1) {
          this.rowHeightCache[i] = {
            top: i > 0 ? this.rowHeightCache[i - 1].bottom + 1 : 0,
            bottom: i > 0 ? this.rowHeightCache[i - 1].bottom + 1 + this.minRowSize : this.minRowSize,
            height: this.minRowSize,
          };
        }
      });
    },
    getElementTop(element) {
      let actualTop = element.offsetTop;
      let current = element.offsetParent;

      while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
      }

      return actualTop;
    },
    applyPageMode() {
      if (this.pageMode) {
        this.addListeners();
      } else {
        this.removeListeners();
      }
    },
    addListeners() {
      this.listenerTarget = this.getListenerTarget();
      this.listenerTarget.addEventListener('scroll', this.onVirtualScroll, {
        passive: true,
      });
      this.listenerTarget.addEventListener('resize', this.onVirtualScroll);
    },
    removeListeners() {
      if (!this.listenerTarget) {
        return;
      }
      this.listenerTarget.removeEventListener('scroll', this.onVirtualScroll);
      this.listenerTarget.removeEventListener('resize', this.onVirtualScroll);
      this.listenerTarget = null;
    },
    getListenerTarget() {
      let target = ScrollParent(this.$el);
      // 修复 Chrome 和 Safari 的全局滚动目标
      if (window.document && (target === window.document.documentElement || target === window.document.body)) {
        target = window;
      }
      return target;
    },
    checkCheckedItem(scope) {
      return this.selection.indexOf(scope.row) > -1;
    },
    onSelectItem(scope) {
      const index = this.selection.indexOf(scope.row);
      if (index === -1) {
        this.selection.push(scope.row);
      } else {
        this.selection.splice(index, 1);
      }
      this.$emit('select', this.selection, scope.row);
      this.$emit('selection-change', this.selection);
    },
    onSelectAll(v) {
      this.selection = v ? [].concat(this.data) : [];

      this.$emit('select-all', this.selection);
      this.$emit('selection-change', this.selection);
    },
    onSortChange({ column, prop, order }) {
      this.$emit('sort-change', { column, prop, order });
    },
    doLayout() {
      this.$refs.VirtualScrollTable.doLayout();
    },
    clearSelection() {
      this.$refs.VirtualScrollTable.clearSelection();
    },
    scrollToBottom() {
      setTimeout(() => {
        const { warpper } = this.getScrollWarppers();
        warpper.scrollTop = warpper.scrollHeight;
      }, 1)
    },
  },
};
</script>

<style scoped lang="scss"></style>
